"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PUBLISH_PORTAL = exports.PORTAL_LOADING = exports.PORTAL_LOADED = exports.PAGE_LOADING = exports.PAGE_LOADED = exports.ORDER_PAGES = exports.FETCH_PORTAL_SUCCESS = exports.DISCARD_PORTAL_DRAFT = exports.ASSET_LOADING = exports.ASSET_LOADED = void 0;
var _actionify = require("@mulesoft/actionify");
// eslint-disable-next-line import/no-extraneous-dependencies

var PUBLISH_PORTAL = exports.PUBLISH_PORTAL = (0, _actionify.buildActionsFor)('Publish portal');
var ASSET_LOADING = exports.ASSET_LOADING = 'Asset loading';
var ASSET_LOADED = exports.ASSET_LOADED = 'Asset loaded';
var FETCH_PORTAL_SUCCESS = exports.FETCH_PORTAL_SUCCESS = 'Fetch Portal Success';
var PORTAL_LOADING = exports.PORTAL_LOADING = 'Portal Loading';
var PORTAL_LOADED = exports.PORTAL_LOADED = 'Portal Loaded';
var PAGE_LOADING = exports.PAGE_LOADING = 'Page Loading';
var PAGE_LOADED = exports.PAGE_LOADED = 'Page Loaded';
var ORDER_PAGES = exports.ORDER_PAGES = (0, _actionify.buildActionsFor)('Order Pages');
var DISCARD_PORTAL_DRAFT = exports.DISCARD_PORTAL_DRAFT = (0, _actionify.buildActionsFor)('Discard Portal Draft');
//# sourceMappingURL=actionTypes.js.map